/* TODO: t() */
/* eslint-disable @typescript-eslint/no-explicit-any */
import autobind from 'class-autobind';
import React, { Component, Fragment } from 'react';
import { View, StyleSheet } from 'react-native';
import { Text, Link } from '../../uiold';
import { showSuccess } from '../../App/AppAlert';
import LoadingIndicator from '../../uiold/LoadingIndicator';
import { getAuthURI, isConnected, validateAuthResult } from './helpers';

import { Account } from '../../../types/shared/Account';

type Props = {
  account: Account | null | undefined;
  children?: React.ReactNode;
  onInvoiceProviderConnected: () => void;
};

type State = {
  isValidating: boolean;
};

class QuickbooksConnect extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    autobind(this);
    this.state = {
      isValidating: false,
    };
  }

  componentDidMount() {
    window.addEventListener('message', this._handleMessage);
  }

  componentWillUnmount() {
    window.removeEventListener('message', this._handleMessage);
  }

  render() {
    let { account, children } = this.props;
    let { isValidating } = this.state;
    if (!account) {
      return <LoadingIndicator />;
    }
    if (isConnected(account)) {
      return <Fragment>{children}</Fragment>;
    }
    // Note: we want to HIDE the link while validating, but not remove it from
    // the DOM. For some reason, if we remove the link, we will break
    // window.opener in the new tab.
    return (
      <View>
        {isValidating ? <LoadingIndicator /> : null}
        <Text style={isValidating ? styles.hidden : undefined}>
          <Link
            href={getAuthURI('mw-oauth2')}
            onPress={this._startValidating}
            allowOpener={true}
          >
            Click here
          </Link>{' '}
          to connect your Quickbooks account.
        </Text>
      </View>
    );
  }

  _handleMessage(event: { [key: string]: any }) {
    let { data, origin } = event;
    if (origin !== window.location.origin) {
      console.error('Event origin mismatch.'); // eslint-disable-line no-console
      return;
    }
    if (
      data &&
      data.actionType === 'AUTH_COMPLETE' &&
      data.service === 'quickbooks'
    ) {
      let responseData = data.search;
      validateAuthResult(
        typeof responseData === 'string' ? responseData.slice(1) : '',
        this._onValidationComplete,
      );
    }
  }

  _startValidating() {
    this.setState({ isValidating: true });
  }

  _onValidationComplete() {
    let { onInvoiceProviderConnected } = this.props;
    onInvoiceProviderConnected();
    showSuccess(
      'Successfully connected the QuickBooks account with MarketWurks',
    );
    this.setState({ isValidating: false });
  }
}

let styles = StyleSheet.create({
  hidden: {
    display: 'none',
  },
});

export default QuickbooksConnect;
